import { render } from "./Documentations.vue?vue&type=template&id=16658576&scoped=true"
import script from "./Documentations.vue?vue&type=script&lang=js"
export * from "./Documentations.vue?vue&type=script&lang=js"

import "./Documentations.vue?vue&type=style&index=0&id=16658576&scoped=true&lang=scss"

import exportComponent from "/Users/skynet/Documents/Sites safe 2026/Safe_Sites_Modifs/SAFE_GROUP/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16658576"]])

export default __exports__